import React, { useEffect } from 'react';
import './TermsAndConditions.scss';
import '../AppComponents/Subscription.scss';
import back from "../assets/icons/back_menu_arrow.png"
import Footer2 from './Footer2';
import logo from "../assets/icons/logo.png"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const TermsAndConditions = ({ openTerms,setOpenTerms,selectedLang,homeLogo}) => {
    // const lang =selectedLang?selectedLang: localStorage.getItem("appLang")?localStorage.getItem("appLang"):'ar';
    const lang = "en";

    const history = useHistory()

    const termsArray = [
      {
        id: "1",
        heading: {
          en: "",
          ar: "",
        },
        text: [
          {
            en: "Please read these Terms and Conditions (\"Terms\", \"Terms and Conditions\") carefully before using Cubegames portal (the \"Service\") operated by Telecubes Mobile Services (\"us\", \"we\", or \"our\").",
            ar: "يُرجى قراءة هذه الشروط والأحكام (\"الشروط\"، \"الشروط والأحكام\") بعناية قبل استخدام بوابة Cubegames (الخدمة) التي تديرها خدمات Telecubes Mobile (\"نحن\"، \"نحن\"، أو \"لنا\").",
          },
        ],
      },
      {
        id: "2",
        heading: {
          en: "",
          ar: "",
        },
        text: [
          {
            en: "Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.",
            ar: "ويشترط وصولكم إلى الخدمة واستخدامها قبولكم لهذه الشروط وامتثالكم لها. وتنطبق هذه الشروط على جميع الزوار والمستخدمين وغيرهم ممن يصلون إلى هذه الخدمة أو يستخدمونها.",
          },
        ],
      },
      {
        id: "3",
        heading: {
          en: "",
          ar: "",
        },
        text: [
          {
            en: "By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.",
            ar: "عند الدخول إلى الخدمة أو استخدامها، فإنك توافق على الالتزام بشروط الخدمة هذه. وإذا كنت لا تتفق مع أي جزء من الشروط، فإنه لا يمكنك الولوج إلى الخدمة.",
          },
        ],
      },
      {
        id: "4",
        heading: {
          en: "Availability, Errors and Inaccuracies",
          ar: "التوافر والأخطاء وعدم الدقة",
        },
        text: [
          {
            en: "We are constantly updating our offerings of products and services on our Service and therefore you may experience delays or temporary unavailability of content while we update information on the Service and in our advertising on other websites.",
            ar: "نحن نقوم بتحديث عروضنا من المنتجات والخدمات بشكل مستمر على خدمتنا، وبالتالي قد تواجه تأخيرات أو انقطاعًا مؤقتًا في المحتوى أثناء تحديث المعلومات على الخدمة وفي إعلاناتنا على مواقع الإنترنت الأخرى.",
          },
          {
            en: "Whilst we always use our best endeavors to keep the Service up to date and available, we do not guarantee the accuracy or completeness of any information including product images, specifications, availability, and services.",
            ar: "بينما نبذل دائمًا قصارى جهدنا للحفاظ على الخدمة محدثة ومتاحة، فإننا لا نضمن دقة أو اكتمال أي معلومات بما في ذلك صور المنتجات، المواصفات، التوافر، والخدمات.",
          },
          {
            en: "We reserve the right to change or update information and to correct errors, inaccuracies, or omissions at any time without prior notice.",
            ar: "نحتفظ بالحق في تغيير أو تحديث المعلومات وتصحيح الأخطاء أو العيوب أو الإغفالات في أي وقت دون إشعار مسبق.",
          },
        ],
      },
      {
        "id": "5",
        "heading": {
          "en": "Subscriptions",
          "ar": "الاشتراكات"
        },
        "text": [
          {
            "en": "Some parts of the Service are billed on a subscription basis (\"Subscription(s)\"). You will be billed in advance on a recurring and periodic basis (\"Billing Cycle\"). Billing cycles are set on a daily, weekly or monthly basis.",
            "ar": "تتقاضى الشركة رسوماً مقابل بعض أجزاء الخدمة على أساس الاشتراك (\"الاشتراك (الاشتراكات)\"). ستدفع مقدمًا على أساس دوري ومتكرر (\"دورة الفواتير\"). يتم تعيين دورات الفوترة على أساس يومي أو أسبوعي أو شهري."
          },
          {
            "en": "At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions unless you cancel it or we cancel it. You may cancel your Subscription renewal either through your online account management page or by contacting our customer support team.",
            "ar": "في نهاية كل دورة فوترة، سيتم تجديد اشتراكك تلقائيًا بنفس الشروط إلا إذا قمت بإلغائه أو قمنا نحن بإلغائه. يمكنك إلغاء تجديد اشتراكك إما من خلال صفحة إدارة حسابك على الإنترنت أو عن طريق الاتصال بفريق دعم العملاء."
          }
        ]
      },
      {
        "id": "6",
        "heading": {
          "en": "Free Trial",
          "ar": "فترة التجربة المجانية"
        },
        "text": [
          {
            "en": "We may, at our sole discretion, offer a Subscription with a free trial for a limited period of time (\"Free Trial\").",
            "ar": "يجوز لنا، ووفقًا لتقديرنا الخاص، منحك اشتراكاً مع فترة تجريبية مجانية لمدة محدودة (\"فترة تجريبية مجانية\")."
          },
          {
            "en": "You may be required to enter your billing information in order to sign up for the Free Trial. If you do enter your billing information when signing up for the Free Trial, you will not be charged by us until the Free Trial has expired. On the last day of the Free Trial period, unless you cancelled your Subscription, you will be automatically charged the applicable Subscription fees for the type of Subscription you have selected.",
            "ar": "قد يُطلب منك إدخال بيانات دفع الفواتير من أجل تسجيل الاشتراك في الإصدار التجريبي المجاني. إذا أدخلت معلومات الفواتير الخاصة بك عند تسجيل الاشتراك في الفترة التجريبية المجانية، فلن نتقاضى أي رسوم حتى انتهاء صلاحية النسخة التجريبية المجانية. إذا لم تقم بإلغاء اشتراكك في اليوم الأخير من الفترة التجريبية المجانية، ستبدأ بالدفع تلقائيًا مقابل رسوم الاشتراك المطبقة لنوع الاشتراك الذي حددته."
          },
          {
            "en": "At any time and without notice, we reserve the right to \n (i) modify the terms and conditions of the Free Trial offer, or (ii) cancel such Free Trial offer.",
            "ar": "في أي وقت ودون إشعار نحتفظ بالحق في (i) تعديل شروط وأحكام عرض الفترة التجريبية المجانية، أو (ii)\nإلغاء عرض الفترة التجريبية المجانية هذا."
          }
        ]
      },
      {
        "id": "7",
        "heading": {
          "en": "No Commitment",
          "ar": "لا يوجد التزام"
        },
        "text": [
          {
            "en": "You're not bound by any long-term commitment with us. You have the freedom to enjoy your subscription indefinitely, subject to the terms in the agreement. You can opt out at any time through the service settings, provided it is done at least one full day before the renewal date.",
            "ar": "أنت لست ملتزمًا بأي عقد طويل الأمد معنا. لديك الحرية في الاستمتاع باشتراكك إلى أجل غير مسمى، وفقًا للشروط الواردة في الاتفاقية. يمكنك إلغاء اشتراكك في أي وقت من خلال إعدادات الخدمة، بشرط أن يتم ذلك على الأقل قبل يوم كامل من تاريخ التجديد."
          },
          {
            "en": "If you cancel mid-subscription period, you will have access until the end of the paid period or free trial. Your subscription will not auto-renew, and no further payments will be deducted. You can always reactivate later. Note that there are generally no refunds or credits for mid-subscription cancellations, except where required by law.",
            "ar": "إذا قمت بإلغاء الاشتراك أثناء فترة الاشتراك، سيكون لديك حق الوصول حتى نهاية الفترة المدفوعة أو التجربة المجانية. لن يتم تجديد اشتراكك تلقائيًا، ولن يتم خصم أي مدفوعات أخرى. يمكنك دائمًا إعادة تفعيل اشتراكك في وقت لاحق. يُرجى ملاحظة أنه عادةً لا توجد استردادات أو أرصدة لإلغاء الاشتراك أثناء الفترة، إلا إذا كان ذلك مطلوبًا بموجب القانون."
          },
          {
            "en": "If your subscription is suspended or terminated, there will be no refunds, credits, or exchanges for unused time, fees, content, or data associated with it.",
            "ar": "إذا تم تعليق اشتراكك أو إنهاؤه، فلن يتم تقديم أي استرداد أو أرصدة أو استبدالات للوقت أو الرسوم أو المحتوى أو البيانات غير المستخدمة المرتبطة به."
          }
        ]
      },
      {
        "id": "8",
        "heading": {
          "en": "Fee Changes",
          "ar": "تغييرات الرسوم"
        },
        "text": [
          {
            "en": "Service owner will provide you with a 30 days prior notice of any change in Subscription fees to give you an opportunity to terminate your Subscription before such change becomes effective.",
            "ar": "سيقوم مالك الخدمة بإعلامك قبل 30 يومًا من أي تغيير في رسوم الاشتراك، وذلك لمنحك الفرصة لإنهاء اشتراكك قبل أن يصبح هذا التغيير ساريًا."
          },
          {
            "en": "Your continued use of the Service after the Subscription fee change comes into effect constitutes your agreement to pay the modified Subscription fee amount.",
            "ar": "يعتبر استمرار استخدامك للخدمة بعد سريان مفعول تغيير رسوم الاشتراك بمثابة موافقة ضمنية على دفع مبلغ رسم الاشتراك المعدل."
          }
        ]
      },
      {
        "id": "9",
        "heading": {
          "en": "Refunds",
          "ar": "عمليات استرداد المدفوعات"
        },
        "text": [
          {
            "en": "Certain refund requests for Subscriptions may be considered by us on a case-by-case basis and granted at our sole discretion.",
            "ar": "قد يتم النظر في بعض طلبات الاسترداد للاشتراكات من قبلنا بشكل فردي ويتم منحها حسب تقديرنا الخاص."
          }
        ]
      },
      {
        "id": "10",
        "heading": {
          "en": "Intellectual Property",
          "ar": "الملكية الفكرية"
        },
        "text": [
          {
            "en": "The Service and its original content (excluding Content provided by users), features and functionality are and will remain the exclusive property of Telecubes Mobile Services and its licensors. The Service is protected by copyright, trademark, and other laws of both the UAE and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent from us.",
            "ar": "تظل الخدمة ومحتواها الأصلي (باستثناء المحتوى المقدم من المستخدمين) والميزات والوظائف ملكية حصرية لشركة Telecubes Mobile ومانحي التراخيص. الخدمة محمية بحقوق الطبع والنشر والعلامات التجارية والقوانين الأخرى لكل من دولة الإمارات العربية المتحدة والدول الأجنبية. لا يجوز استخدام علاماتنا التجارية والزي الرسمي في أي منتج أو خدمة دون موافقة كتابية مسبقة منا."
          }
        ]
      },
      {
        "id": "11",
        "heading": {
          "en": "Limitation of Liability",
          "ar": "حدود المسؤولية والالتزام"
        },
        "text": [
          {
            "en": "In no event shall we, nor our directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from\n (i) your access to or use of or inability to access or use the Service;\n (ii) any conduct or content of any third party on the Service;\n (iii) any content obtained from the Service; and\n (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.",
            "ar": "لن نتحمل نحن، بأي حال من الأحوال، ولا مديريها أو موظفيها أو شركائها أو وكلاءها أو مورديها أو الشركات التابعة لها، مسؤولية أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية، بما في ذلك على سبيل المثال لا الحصر، خسارة الأرباح أو البيانات أو الاستخدام، أو الشهرة، أو غيرها من الخسائر غير الملموسة، الناتجة عن\n(i) دخولك إلى الخدمة أو استخدامها أو عدم القدرة على الدخول إليها أو استخدامها؛\n(ii) وضع أي سلوك أو محتوى لأي طرف ثالث على الخدمة؛\n(iii) أي محتوى حصلت عليه من الخدمة؛ و\n(iv) الوصول غير المصرح به أو استخدام أو تغيير عمليات الإرسال أو المحتوى الخاص بك، سواء كان ذلك على أساس الضمان أو العقد أو الضرر (بما في ذلك الإهمال) أو أي نظرية قانونية أخرى، سواء تم إبلاغنا باحتمال حدوث هذا الضرر أم لا، وحتى إذا وجد أن العلاج المنصوص عليه في هذه الاتفاقية قد فشل في تحقيق الغرض الأساسي منه."
          }
        ]
      },
      {
        "id": "12",
        "heading": {
          "en": "Disclaimer",
          "ar": "إخلاء المسؤولية"
        },
        "text": [
          {
            "en": "Your use of the Service is at your sole risk. The Service is provided on an (AS IS) and (AS AVAILABLE) basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.we and our subsidiaries, affiliates, and its licensors do not warrant that\n a) the Service will function uninterrupted, secure or available at any particular time or location;\n b) any errors or defects will be corrected;\n c) the results of using the Service will meet your requirements.",
            "ar":"تقع مسؤولية استخدامك للخدمة على عاتقك وحدك. الخدمة مقدمة على أساس (كما هي) و (كما هي متوفرة). تقدم الخدمة دون ضمانات من أي نوع، سواء كانت صريحة أو ضمنية، بما في ذلك، على سبيل المثال لا الحصر، الضمانات الضمنية الخاصة بالتسويق أو الملاءمة لغرض معين أو عدم التعدي أو في سياق الأداء. نحن وشركاتنا التابعة، والشركات المرتبطة بنا، ومرخصونا لا نضمن أن\nأ) الخدمة ستعمل دون انقطاع أو ستكون آمنة أو متاحة في أي وقت أو مكان معين؛\nب) سيتم تصحيح أي أخطاء أو عيوب؛\nج) ستلبي نتائج استخدام الخدمة متطلباتك."
          }
        ]
      },
      {
        "id": "13",
        "heading": {
          "en": "Governing Law",
          "ar": "القانون الحاكم"
        },
        "text": [
          {
            "en": "These Terms shall be governed and construed in accordance with the laws of UAE, without regard to its conflict of law provisions.",
            "ar": "تخضع هذه الشروط وتفسر وفقًا لقوانين دولة الإمارات العربية المتحدة، بغض النظر عن تعارضها مع أحكام القانون."
          },
          {
            "en": "Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.",
            "ar":"فشلنا في إنفاذ أي حق أو حكم من هذه الشروط لا يعتبر تنازلاً عن هذه الحقوق. إذا اعتبر أي حكم وارد في هذه الشروط باطلاً أو غير قابل للإنفاذ من قبل المحكمة، فستظل الأحكام المتبقية من هذه الشروط سارية المفعول. تشكل هذه الشروط كامل الاتفاقية بيننا فيما يتعلق بخدمتنا، وتلغي أي اتفاقات سابقة قد تكون بيننا بشأن الخدمة وتحل محلها."
          }
        ]
      },
      {
        "id": "14",
        "heading": {
          "en": "Changes",
          "ar": "التغييرات"
        },
        "text": [
          {
            "en": "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days’ notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.",
            "ar": "نحتفظ بحق تعديل أو استبدال هذه الشروط في أي وقت وحسب تقديرنا الخاص. إذا كان التعديل مادياً، سنحاول إرسال إشعار قبل 30 يومًا على الأقل من سريان مفعول أي شروط جديدة. ويعود لنا فقط تقدير ما يمكن اعتباره تغييراً مادياً."
          },
          {
            "en": "By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.",
            "ar" :"من خلال الاستمرار في الدخول إلى خدمتنا أو استخدامها بعد أن تصبح هذه التعديلات سارية المفعول، يعتبر بمثابة موافقة منك على الالتزام بالشروط المعدلة. إن كنت لا توافق على الشروط الجديدة، فيُرجى التوقف عن استخدام الخدمة."
          }
        ]
      },
      {
        "id": "15",
        "heading": {
          "en": "Contact Us",
          "ar": "تواصل معنا"
        },
        "text": [
          {
            "en": "If you have any questions about these Terms, please contact us on contact@telecubesmobile.com",
            "ar": "إذا كانت لديك أي أسئلة حول هذه الشروط، فيرجى الاتصال بنا على contact@telecubesmobile.com."
          }
        ]
      }

    ];
    

    const openLP =()=>{
        // history.push("/")
        if(openTerms && openTerms!==undefined)
            {
                setOpenTerms(false)
            }
            else{

               history.push("/subs")
            }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
      <div
      className="terms-conditions-container"
  >
            {/* {homeLogo && <img src={homeLogo} alt="Home Logo" className="terms-home-logo"/>}*/}
            <div className="images">
            <img 
                className="lang"
                src={back}
                alt="back"
                onClick={openLP}></img>
                <img 
                className="logosub"
                alt="logosub"
                src={homeLogo ? homeLogo : logo}></img>
                
            </div> 
            <div className={`termsText ${lang === "ar" ? "rtl" : ""}`}>
            <h1>{lang === "en" ? "Terms and Conditions (Terms)" : "الشروط والأحكام ( الشروط )"}</h1>
            <p>{lang === "en" ? "" : ""}</p>
            {termsArray && termsArray.map((item)=>{
                return(
                    <>
                    <h1>{item.heading[lang]}</h1>
                    {item.text &&
          item.text.map((textItem, index) => (
            <p key={index}>{textItem[lang] ? textItem[lang] : ""}</p>
          ))}
                    </>
                )
            })}
           
        
            <Footer2/>
        </div>
        </div>
    );
}

export default TermsAndConditions;
